import i18n from 'i18next';

import { registerValidator } from 'core/forms';

const isPositiveInteger = ({ fieldValue, validator }) => ({
  hasError: fieldValue != null && (!Number.isInteger(fieldValue) || fieldValue < 1),
  error: i18n.t('error-not-positive-integer'),
  isRequired: validator?.isRequired,
});

registerValidator('isPositiveInteger', isPositiveInteger);

export default isPositiveInteger;
